module.exports = __webpack_public_path__ + "static/img/view-03-search@m.f729b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-03-search@m.jpg
// module id = mPZ6
// module chunks = 0